// // src/pages/CompanySettings.tsx
// import React, { useState, useEffect, useCallback } from 'react';
// import {
//     Container,
//     Row,
//     Col,
//     Card,
//     CardBody,
//     CardHeader,
//     Button,
//     Form,
//     FormGroup,
//     Label,
//     Input,
//     Alert,
//     Spinner,
//     Table,
// } from 'reactstrap';
// import {
//     Save,
//     RefreshCw,
//     CreditCard,
//     Clock,
//     MapPin,
//     CheckCircle,
//     AlertCircle,
//     // Building,
//     Phone,
//     FileText,
//     DollarSign,
// } from 'react-feather';
// import BreadCrumb from '../../Components/Common/BreadCrumb';
// import { toast } from 'react-toastify';
// import { apiClient } from '../../helpers/api_helper';

// // Types
// interface CompanySettings {
//     id: number;
//     name: string;
//     gst?: string;
//     pan?: string;
//     address?: string;
//     contact_no?: string;
//     working_from_time?: string;
//     working_to_time?: string;
//     bank_name?: string;
//     bank_account_no?: string;
//     ifsc_code?: string;
//     bank_branch?: string;
//     half_day_time?: string;
//     status: boolean;
//     created_at?: string;
//     updated_at?: string;
// }

// const CompanySettings: React.FC = () => {
//     // State
//     const [loading, setLoading] = useState(true);
//     const [saving, setSaving] = useState(false);
//     const [error, setError] = useState('');
//     const [success, setSuccess] = useState('');
//     const [settings, setSettings] = useState<CompanySettings | null>(null);
//     const [settingsExist, setSettingsExist] = useState(false);

//     // Form data
//     const [formData, setFormData] = useState<Partial<CompanySettings>>({
//         name: '',
//         gst: '',
//         pan: '',
//         address: '',
//         contact_no: '',
//         working_from_time: '',
//         working_to_time: '',
//         bank_name: '',
//         bank_account_no: '',
//         ifsc_code: '',
//         bank_branch: '',
//         half_day_time: '',
//         status: true,
//     });

//     // Validation errors
//     const [validationErrors, setValidationErrors] = useState<Record<string, string>>({});

//     // Fetch settings
//     const fetchSettings = useCallback(async () => {
//         setLoading(true);
//         setError('');

//         try {
//             const response = await apiClient.get('/company-settings');
            
//             if (response && response.data) {
//                 setSettings(response.data);
//                 setSettingsExist(true);
//                 setFormData({
//                     name: response.data.name || '',
//                     gst: response.data.gst || '',
//                     pan: response.data.pan || '',
//                     address: response.data.address || '',
//                     contact_no: response.data.contact_no || '',
//                     working_from_time: response.data.working_from_time || '',
//                     working_to_time: response.data.working_to_time || '',
//                     bank_name: response.data.bank_name || '',
//                     bank_account_no: response.data.bank_account_no || '',
//                     ifsc_code: response.data.ifsc_code || '',
//                     bank_branch: response.data.bank_branch || '',
//                     half_day_time: response.data.half_day_time || '',
//                     status: response.data.status !== undefined ? response.data.status : true,
//                 });
//             }
//         } catch (error: any) {
//             console.error('Error fetching settings:', error);
            
//             if (error.response?.status === 404) {
//                 setSettingsExist(false);
//                 setError('Company settings not found. Please initialize settings.');
//             } else {
//                 setError(error.message || 'Failed to fetch company settings');
//                 toast.error('Failed to load company settings');
//             }
//         } finally {
//             setLoading(false);
//         }
//     }, []);

//     // Create new settings
//     const createSettings = useCallback(async () => {
//         setSaving(true);
//         setError('');

//         try {
//             const response = await apiClient.get('/company-settings/ensure');
            
//             if (response && response.data) {
//                 setSettings(response.data);
//                 setSettingsExist(true);
//                 setFormData({
//                     name: response.data.name || '',
//                     gst: response.data.gst || '',
//                     pan: response.data.pan || '',
//                     address: response.data.address || '',
//                     contact_no: response.data.contact_no || '',
//                     working_from_time: response.data.working_from_time || '',
//                     working_to_time: response.data.working_to_time || '',
//                     bank_name: response.data.bank_name || '',
//                     bank_account_no: response.data.bank_account_no || '',
//                     ifsc_code: response.data.ifsc_code || '',
//                     bank_branch: response.data.bank_branch || '',
//                     half_day_time: response.data.half_day_time || '',
//                     status: response.data.status !== undefined ? response.data.status : true,
//                 });
//                 toast.success('Company settings created successfully!');
//                 setSuccess('Company settings created successfully!');
//                 setTimeout(() => setSuccess(''), 3000);
//             }
//         } catch (error: any) {
//             console.error('Error creating settings:', error);
//             setError(error.message || 'Failed to create company settings');
//             toast.error('Failed to create company settings');
//         } finally {
//             setSaving(false);
//         }
//     }, []);

//     // Initial fetch
//     useEffect(() => {
//         fetchSettings();
//     }, [fetchSettings]);

//     // Handle form field changes
//     const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
//         const { name, value, type } = e.target;
//         const checked = (e.target as HTMLInputElement).checked;

//         setFormData(prev => ({
//             ...prev,
//             [name]: type === 'checkbox' ? checked : value,
//         }));

//         if (validationErrors[name]) {
//             setValidationErrors(prev => {
//                 const newErrors = { ...prev };
//                 delete newErrors[name];
//                 return newErrors;
//             });
//         }
//     };

//     // Validate form
//     const validateForm = (): boolean => {
//         const errors: Record<string, string> = {};

//         if (!formData.name?.trim()) {
//             errors.name = 'Company name is required';
//         }

//         if (formData.gst && !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(formData.gst)) {
//             errors.gst = 'Invalid GST format (e.g., 22AAAAA0000A1Z1)';
//         }

//         if (formData.pan && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(formData.pan)) {
//             errors.pan = 'Invalid PAN format (e.g., ABCDE1234F)';
//         }

//         if (formData.contact_no && !/^[0-9]{10}$/.test(formData.contact_no)) {
//             errors.contact_no = 'Phone number must be 10 digits';
//         }

//         if (formData.ifsc_code && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(formData.ifsc_code)) {
//             errors.ifsc_code = 'Invalid IFSC code format (e.g., SBIN0001234)';
//         }

//         const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
//         if (formData.working_from_time && !timeRegex.test(formData.working_from_time)) {
//             errors.working_from_time = 'Invalid time format (HH:MM)';
//         }
//         if (formData.working_to_time && !timeRegex.test(formData.working_to_time)) {
//             errors.working_to_time = 'Invalid time format (HH:MM)';
//         }
//         if (formData.half_day_time && !timeRegex.test(formData.half_day_time)) {
//             errors.half_day_time = 'Invalid time format (HH:MM)';
//         }

//         setValidationErrors(errors);

//         if (Object.keys(errors).length > 0) {
//             const firstError = Object.values(errors)[0];
//             toast.error(firstError);
//         }

//         return Object.keys(errors).length === 0;
//     };

//     // Handle form submit
//     const handleSubmit = async (e: React.FormEvent) => {
//         e.preventDefault();

//         if (!validateForm()) {
//             return;
//         }

//         setSaving(true);
//         setError('');
//         setSuccess('');

//         try {
//             const cleanData: any = { ...formData };
            
//             Object.keys(cleanData).forEach(key => {
//                 if (cleanData[key] === '' || cleanData[key] === null || cleanData[key] === undefined) {
//                     delete cleanData[key];
//                 }
//             });

//             if (settingsExist && settings) {
//                 await apiClient.put('/company-settings', cleanData);
//                 toast.success('Company settings updated successfully!');
//                 setSuccess('Company settings updated successfully!');
//             } else {
//                 await apiClient.patch('/company-settings', cleanData);
//                 toast.success('Company settings created successfully!');
//                 setSuccess('Company settings created successfully!');
//                 setSettingsExist(true);
//             }

//             await fetchSettings();
//             setTimeout(() => setSuccess(''), 3000);
//         } catch (error: any) {
//             console.error('Error saving settings:', error);
//             const errorMessage = error.response?.data?.message || error.message || 'Failed to save company settings';
//             setError(errorMessage);
//             toast.error(errorMessage);
//         } finally {
//             setSaving(false);
//         }
//     };

//     // Handle reset
//     const handleReset = async () => {
//         await fetchSettings();
//         toast.info('Settings reloaded');
//     };

//     // Loading state
//     if (loading) {
//         return (
//             <div className="page-content">
//                 <Container fluid>
//                     <BreadCrumb title="Company Settings" pageTitle="Settings" />
//                     <Row>
//                         <Col lg={12}>
//                             <Card>
//                                 <CardBody className="text-center py-5">
//                                     <Spinner color="primary" className="me-2" />
//                                     <span>Loading company settings...</span>
//                                 </CardBody>
//                             </Card>
//                         </Col>
//                     </Row>
//                 </Container>
//             </div>
//         );
//     }

//     return (
//         <div className="page-content">
//             <Container fluid>
//                 <BreadCrumb title="Company Settings" pageTitle="Settings" />

//                 <Row>
//                     <Col lg={12}>
//                         <Card>
//                             <CardHeader className="d-flex justify-content-between align-items-center flex-wrap gap-2">
//                                 <div>
//                                     <h5 className="card-title mb-0">Company Settings</h5>
//                                     {settings && (
//                                         <small className="text-muted">
//                                             Last updated: {new Date(settings.updated_at || '').toLocaleString()}
//                                         </small>
//                                     )}
//                                 </div>
//                                 <div className="d-flex gap-2">
//                                     <Button
//                                         color="secondary"
//                                         size="sm"
//                                         onClick={handleReset}
//                                         disabled={saving}
//                                     >
//                                         <RefreshCw size={14} className="me-1" />
//                                         Reset
//                                     </Button>
//                                     {!settingsExist && (
//                                         <Button
//                                             color="primary"
//                                             size="sm"
//                                             onClick={createSettings}
//                                             disabled={saving}
//                                         >
//                                             {/* <Building size={14} className="me-1" /> */}
//                                             Initialize Settings
//                                         </Button>
//                                     )}
//                                 </div>
//                             </CardHeader>

//                             <CardBody>
//                                 {/* Alerts */}
//                                 {error && (
//                                     <Alert color="danger" className="mb-3">
//                                         <AlertCircle size={16} className="me-2" />
//                                         {error}
//                                         {!settingsExist && (
//                                             <Button
//                                                 color="primary"
//                                                 size="sm"
//                                                 className="ms-3"
//                                                 onClick={createSettings}
//                                                 disabled={saving}
//                                             >
//                                                 Initialize Now
//                                             </Button>
//                                         )}
//                                     </Alert>
//                                 )}

//                                 {success && (
//                                     <Alert color="success" className="mb-3">
//                                         <CheckCircle size={16} className="me-2" />
//                                         {success}
//                                     </Alert>
//                                 )}

//                                 {/* Settings exist check */}
//                                 {!settingsExist && !error && (
//                                     <Alert color="warning" className="mb-3">
//                                         <AlertCircle size={16} className="me-2" />
//                                         No company settings found. Please initialize settings to continue.
//                                         <Button
//                                             color="primary"
//                                             size="sm"
//                                             className="ms-3"
//                                             onClick={createSettings}
//                                             disabled={saving}
//                                         >
//                                             Initialize Settings
//                                         </Button>
//                                     </Alert>
//                                 )}

//                                 {settingsExist && (
//                                     <Form onSubmit={handleSubmit}>
//                                         {/* Company Information Section */}
//                                         <div className="mb-4">
//                                             <h6 className="text-primary mb-3">
//                                                 {/* <Building size={16} className="me-2" /> */}
//                                                 Company Information
//                                             </h6>
//                                             <div className="table-responsive">
//                                                 <Table bordered className="mb-0">
//                                                     <tbody>
//                                                         <tr>
//                                                             <td className="bg-light" style={{ width: '200px', fontWeight: '600' }}>
//                                                                 Company Name <span className="text-danger">*</span>
//                                                             </td>
//                                                             <td>
//                                                                 <Input
//                                                                     type="text"
//                                                                     name="name"
//                                                                     value={formData.name || ''}
//                                                                     onChange={handleInputChange}
//                                                                     invalid={!!validationErrors.name}
//                                                                     bsSize="sm"
//                                                                     placeholder="Enter company name"
//                                                                 />
//                                                                 {validationErrors.name && (
//                                                                     <div className="text-danger small mt-1">{validationErrors.name}</div>
//                                                                 )}
//                                                             </td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td className="bg-light" style={{ fontWeight: '600' }}>
//                                                                 <FileText size={14} className="me-1" />
//                                                                 GST Number
//                                                             </td>
//                                                             <td>
//                                                                 <Input
//                                                                     type="text"
//                                                                     name="gst"
//                                                                     value={formData.gst || ''}
//                                                                     onChange={handleInputChange}
//                                                                     invalid={!!validationErrors.gst}
//                                                                     bsSize="sm"
//                                                                     placeholder="e.g., 22AAAAA0000A1Z1"
//                                                                 />
//                                                                 {validationErrors.gst && (
//                                                                     <div className="text-danger small mt-1">{validationErrors.gst}</div>
//                                                                 )}
//                                                                 
//                                                             </td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td className="bg-light" style={{ fontWeight: '600' }}>
//                                                                 <FileText size={14} className="me-1" />
//                                                                 PAN Number
//                                                             </td>
//                                                             <td>
//                                                                 <Input
//                                                                     type="text"
//                                                                     name="pan"
//                                                                     value={formData.pan || ''}
//                                                                     onChange={handleInputChange}
//                                                                     invalid={!!validationErrors.pan}
//                                                                     bsSize="sm"
//                                                                     placeholder="e.g., ABCDE1234F"
//                                                                 />
//                                                                 {validationErrors.pan && (
//                                                                     <div className="text-danger small mt-1">{validationErrors.pan}</div>
//                                                                 )}
//                                                                 
//                                                             </td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td className="bg-light" style={{ fontWeight: '600' }}>
//                                                                 <Phone size={14} className="me-1" />
//                                                                 Contact Number
//                                                             </td>
//                                                             <td>
//                                                                 <Input
//                                                                     type="tel"
//                                                                     name="contact_no"
//                                                                     value={formData.contact_no || ''}
//                                                                     onChange={handleInputChange}
//                                                                     invalid={!!validationErrors.contact_no}
//                                                                     bsSize="sm"
//                                                                     placeholder="10-digit phone number"
//                                                                     maxLength={10}
//                                                                 />
//                                                                 {validationErrors.contact_no && (
//                                                                     <div className="text-danger small mt-1">{validationErrors.contact_no}</div>
//                                                                 )}
//                                                                 
//                                                             </td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td className="bg-light" style={{ fontWeight: '600' }}>
//                                                                 Status
//                                                             </td>
//                                                             <td>
//                                                                 <FormGroup check>
//                                                                     <Label check>
//                                                                         <Input
//                                                                             type="checkbox"
//                                                                             name="status"
//                                                                             checked={formData.status !== false}
//                                                                             onChange={handleInputChange}
//                                                                         />
//                                                                         <span className="ms-2">Active</span>
//                                                                     </Label>
//                                                                 </FormGroup>
//                                                             </td>
//                                                         </tr>
//                                                     </tbody>
//                                                 </Table>
//                                             </div>
//                                         </div>

//                                         {/* Working Hours Section */}
//                                         <div className="mb-4">
//                                             <h6 className="text-primary mb-3">
//                                                 <Clock size={16} className="me-2" />
//                                                 Working Hours
//                                             </h6>
//                                             <div className="table-responsive">
//                                                 <Table bordered className="mb-0">
//                                                     <tbody>
//                                                         <tr>
//                                                             <td className="bg-light" style={{ width: '200px', fontWeight: '600' }}>
//                                                                 Working From
//                                                             </td>
//                                                             <td>
//                                                                 <Input
//                                                                     type="time"
//                                                                     name="working_from_time"
//                                                                     value={formData.working_from_time || ''}
//                                                                     onChange={handleInputChange}
//                                                                     invalid={!!validationErrors.working_from_time}
//                                                                     bsSize="sm"
//                                                                 />
//                                                                 {validationErrors.working_from_time && (
//                                                                     <div className="text-danger small mt-1">{validationErrors.working_from_time}</div>
//                                                                 )}
//                                                                 <small className="text-muted">e.g., 09:00</small>
//                                                             </td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td className="bg-light" style={{ fontWeight: '600' }}>
//                                                                 Working To
//                                                             </td>
//                                                             <td>
//                                                                 <Input
//                                                                     type="time"
//                                                                     name="working_to_time"
//                                                                     value={formData.working_to_time || ''}
//                                                                     onChange={handleInputChange}
//                                                                     invalid={!!validationErrors.working_to_time}
//                                                                     bsSize="sm"
//                                                                 />
//                                                                 {validationErrors.working_to_time && (
//                                                                     <div className="text-danger small mt-1">{validationErrors.working_to_time}</div>
//                                                                 )}
//                                                                 <small className="text-muted">e.g., 18:00</small>
//                                                             </td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td className="bg-light" style={{ fontWeight: '600' }}>
//                                                                 Half Day Time
//                                                             </td>
//                                                             <td>
//                                                                 <Input
//                                                                     type="time"
//                                                                     name="half_day_time"
//                                                                     value={formData.half_day_time || ''}
//                                                                     onChange={handleInputChange}
//                                                                     invalid={!!validationErrors.half_day_time}
//                                                                     bsSize="sm"
//                                                                 />
//                                                                 {validationErrors.half_day_time && (
//                                                                     <div className="text-danger small mt-1">{validationErrors.half_day_time}</div>
//                                                                 )}
//                                                                 <small className="text-muted">e.g., 13:00</small>
//                                                             </td>
//                                                         </tr>
//                                                     </tbody>
//                                                 </Table>
//                                             </div>
//                                         </div>

//                                         {/* Bank Details Section */}
//                                         <div className="mb-4">
//                                             <h6 className="text-primary mb-3">
//                                                 <CreditCard size={16} className="me-2" />
//                                                 Bank Details
//                                             </h6>
//                                             <div className="table-responsive">
//                                                 <Table bordered className="mb-0">
//                                                     <tbody>
//                                                         <tr>
//                                                             <td className="bg-light" style={{ width: '200px', fontWeight: '600' }}>
//                                                                 Bank Name
//                                                             </td>
//                                                             <td>
//                                                                 <Input
//                                                                     type="text"
//                                                                     name="bank_name"
//                                                                     value={formData.bank_name || ''}
//                                                                     onChange={handleInputChange}
//                                                                     bsSize="sm"
//                                                                     placeholder="Enter bank name"
//                                                                 />
//                                                                 
//                                                             </td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td className="bg-light" style={{ fontWeight: '600' }}>
//                                                                 Account Number
//                                                             </td>
//                                                             <td>
//                                                                 <Input
//                                                                     type="text"
//                                                                     name="bank_account_no"
//                                                                     value={formData.bank_account_no || ''}
//                                                                     onChange={handleInputChange}
//                                                                     bsSize="sm"
//                                                                     placeholder="Enter account number"
//                                                                 />
//                                                                 
//                                                             </td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td className="bg-light" style={{ fontWeight: '600' }}>
//                                                                 IFSC Code
//                                                             </td>
//                                                             <td>
//                                                                 <Input
//                                                                     type="text"
//                                                                     name="ifsc_code"
//                                                                     value={formData.ifsc_code || ''}
//                                                                     onChange={handleInputChange}
//                                                                     invalid={!!validationErrors.ifsc_code}
//                                                                     bsSize="sm"
//                                                                     placeholder="e.g., SBIN0001234"
//                                                                 />
//                                                                 {validationErrors.ifsc_code && (
//                                                                     <div className="text-danger small mt-1">{validationErrors.ifsc_code}</div>
//                                                                 )}
//                                                                 
//                                                             </td>
//                                                         </tr>
//                                                         <tr>
//                                                             <td className="bg-light" style={{ fontWeight: '600' }}>
//                                                                 Bank Branch
//                                                             </td>
//                                                             <td>
//                                                                 <Input
//                                                                     type="text"
//                                                                     name="bank_branch"
//                                                                     value={formData.bank_branch || ''}
//                                                                     onChange={handleInputChange}
//                                                                     bsSize="sm"
//                                                                     placeholder="Enter branch name"
//                                                                 />
//                                                                 
//                                                             </td>
//                                                         </tr>
//                                                     </tbody>
//                                                 </Table>
//                                             </div>
//                                         </div>

//                                         {/* Address Section */}
//                                         <div className="mb-4">
//                                             <h6 className="text-primary mb-3">
//                                                 <MapPin size={16} className="me-2" />
//                                                 Address
//                                             </h6>
//                                             <div className="table-responsive">
//                                                 <Table bordered className="mb-0">
//                                                     <tbody>
//                                                         <tr>
//                                                             <td className="bg-light" style={{ width: '200px', fontWeight: '600' }}>
//                                                                 Address
//                                                             </td>
//                                                             <td>
//                                                                 <Input
//                                                                     type="textarea"
//                                                                     name="address"
//                                                                     value={formData.address || ''}
//                                                                     onChange={handleInputChange}
//                                                                     bsSize="sm"
//                                                                     rows={3}
//                                                                     placeholder="Enter company address"
//                                                                 />
//                                                                 
//                                                             </td>
//                                                         </tr>
//                                                     </tbody>
//                                                 </Table>
//                                             </div>
//                                         </div>

//                                         {/* Form Actions */}
//                                         <div className="mt-4 pt-3 border-top">
//                                             <div className="d-flex justify-content-end gap-2">
//                                                 <Button
//                                                     color="secondary"
//                                                     onClick={handleReset}
//                                                     disabled={saving}
//                                                 >
//                                                     <RefreshCw size={14} className="me-1" />
//                                                     Reset
//                                                 </Button>
//                                                 <Button
//                                                     color="primary"
//                                                     type="submit"
//                                                     disabled={saving}
//                                                 >
//                                                     {saving ? (
//                                                         <>
//                                                             <Spinner size="sm" className="me-2" />
//                                                             Saving...
//                                                         </>
//                                                     ) : (
//                                                         <>
//                                                             <Save size={14} className="me-1" />
//                                                             Save Changes
//                                                         </>
//                                                     )}
//                                                 </Button>
//                                             </div>
//                                         </div>
//                                     </Form>
//                                 )}
//                             </CardBody>
//                         </Card>
//                     </Col>
//                 </Row>
//             </Container>
//         </div>
//     );
// };

// export default CompanySettings;
// src/pages/CompanySettings.tsx
import React, { useState, useEffect, useCallback } from 'react';
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardHeader,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Alert,
    Spinner,
    Table,
} from 'reactstrap';
import {
    Save,
    RefreshCw,
    CreditCard,
    Clock,
    MapPin,
    CheckCircle,
    AlertCircle,
    Briefcase,
    Phone,
    FileText,
} from 'react-feather';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { toast } from 'react-toastify';
import { apiClient } from '../../helpers/api_helper';

// Types
interface CompanySettings {
    id: number;
    name: string;
    gst?: string;
    pan?: string;
    address?: string;
    contact_no?: string;
    working_from_time?: string;
    working_to_time?: string;
    bank_name?: string;
    bank_account_no?: string;
    ifsc_code?: string;
    bank_branch?: string;
    half_day_time?: number | string;
    full_day_time?: number | string;
    ot_grace_time?: number | string;
    status: boolean;
    created_at?: string;
    updated_at?: string;
}

const CompanySettings: React.FC = () => {
    // State
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [settings, setSettings] = useState<CompanySettings | null>(null);
    const [settingsExist, setSettingsExist] = useState(false);

    // Form data
    const [formData, setFormData] = useState<Partial<CompanySettings>>({
        name: '',
        gst: '',
        pan: '',
        address: '',
        contact_no: '',
        working_from_time: '',
        working_to_time: '',
        bank_name: '',
        bank_account_no: '',
        ifsc_code: '',
        bank_branch: '',
        half_day_time: '',
        full_day_time: '',
        ot_grace_time: '',
        status: true,
    });

    // Validation errors
    const [validationErrors, setValidationErrors] = useState<Record<string, string>>({});

    // Fetch settings
    const fetchSettings = useCallback(async () => {
        setLoading(true);
        setError('');

        try {
            const response = await apiClient.get('/company-settings');
            
            if (response && response.data) {
                setSettings(response.data);
                setSettingsExist(true);
                setFormData({
                    name: response.data.name || '',
                    gst: response.data.gst || '',
                    pan: response.data.pan || '',
                    address: response.data.address || '',
                    contact_no: response.data.contact_no || '',
                    working_from_time: response.data.working_from_time || '',
                    working_to_time: response.data.working_to_time || '',
                    bank_name: response.data.bank_name || '',
                    bank_account_no: response.data.bank_account_no || '',
                    ifsc_code: response.data.ifsc_code || '',
                    bank_branch: response.data.bank_branch || '',
                    half_day_time: response.data.half_day_time || '',
                    full_day_time: response.data.full_day_time !== undefined && response.data.full_day_time !== null ? response.data.full_day_time : '',
                    ot_grace_time: response.data.ot_grace_time !== undefined && response.data.ot_grace_time !== null ? response.data.ot_grace_time : '',
                    status: response.data.status !== undefined ? response.data.status : true,
                });
            }
        } catch (error: any) {
            console.error('Error fetching settings:', error);
            
            if (error.response?.status === 404) {
                setSettingsExist(false);
                setError('Company settings not found. Please initialize settings.');
            } else {
                setError(error.message || 'Failed to fetch company settings');
                toast.error('Failed to load company settings');
            }
        } finally {
            setLoading(false);
        }
    }, []);

    // Create new settings
    const createSettings = useCallback(async () => {
        setSaving(true);
        setError('');

        try {
            const response = await apiClient.get('/company-settings/ensure');
            
            if (response && response.data) {
                setSettings(response.data);
                setSettingsExist(true);
                setFormData({
                    name: response.data.name || '',
                    gst: response.data.gst || '',
                    pan: response.data.pan || '',
                    address: response.data.address || '',
                    contact_no: response.data.contact_no || '',
                    working_from_time: response.data.working_from_time || '',
                    working_to_time: response.data.working_to_time || '',
                    bank_name: response.data.bank_name || '',
                    bank_account_no: response.data.bank_account_no || '',
                    ifsc_code: response.data.ifsc_code || '',
                    bank_branch: response.data.bank_branch || '',
                    half_day_time: response.data.half_day_time || '',
                    full_day_time: response.data.full_day_time !== undefined && response.data.full_day_time !== null ? response.data.full_day_time : '',
                    ot_grace_time: response.data.ot_grace_time !== undefined && response.data.ot_grace_time !== null ? response.data.ot_grace_time : '',
                    status: response.data.status !== undefined ? response.data.status : true,
                });
                toast.success('Company settings created successfully!');
                setSuccess('Company settings created successfully!');
                setTimeout(() => setSuccess(''), 3000);
            }
        } catch (error: any) {
            console.error('Error creating settings:', error);
            setError(error.message || 'Failed to create company settings');
            toast.error('Failed to create company settings');
        } finally {
            setSaving(false);
        }
    }, []);

    // Initial fetch
    useEffect(() => {
        fetchSettings();
    }, [fetchSettings]);

    // Handle form field changes
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value, type } = e.target;
        const checked = (e.target as HTMLInputElement).checked;

        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));

        if (validationErrors[name]) {
            setValidationErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };

    // Handle time input click to open picker
    const handleTimeInputClick = (e: React.MouseEvent<HTMLInputElement>) => {
        (e.target as HTMLInputElement).showPicker?.();
    };

    // Validate form
    const validateForm = (): boolean => {
        const errors: Record<string, string> = {};

        if (!formData.name?.trim()) {
            errors.name = 'Company name is required';
        }

        if (formData.gst && !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(formData.gst)) {
            errors.gst = 'Invalid GST format (e.g., 22AAAAA0000A1Z1)';
        }

        if (formData.pan && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(formData.pan)) {
            errors.pan = 'Invalid PAN format (e.g., ABCDE1234F)';
        }

        if (formData.contact_no && !/^[0-9]{10}$/.test(formData.contact_no)) {
            errors.contact_no = 'Phone number must be 10 digits';
        }

        if (formData.ifsc_code && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(formData.ifsc_code)) {
            errors.ifsc_code = 'Invalid IFSC code format (e.g., SBIN0001234)';
        }

        const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
        if (formData.working_from_time && !timeRegex.test(formData.working_from_time)) {
            errors.working_from_time = 'Invalid time format (HH:MM)';
        }
        if (formData.working_to_time && !timeRegex.test(formData.working_to_time)) {
            errors.working_to_time = 'Invalid time format (HH:MM)';
        }

        if (formData.full_day_time !== undefined && formData.full_day_time !== '' && formData.full_day_time !== null) {
            const val = parseFloat(formData.full_day_time as string);
            if (isNaN(val) || val <= 0) {
                errors.full_day_time = 'Full day time must be a positive number';
            }
        }
        if (formData.half_day_time !== undefined && formData.half_day_time !== '' && formData.half_day_time !== null) {
            const val = parseFloat(formData.half_day_time as string);
            if (isNaN(val) || val <= 0) {
                errors.half_day_time = 'Half day time must be a positive number';
            }
        }
        if (formData.ot_grace_time !== undefined && formData.ot_grace_time !== '' && formData.ot_grace_time !== null) {
            const val = parseFloat(formData.ot_grace_time as string);
            if (isNaN(val) || val < 0) {
                errors.ot_grace_time = 'OT grace time must be a non-negative number';
            }
        }

        setValidationErrors(errors);

        if (Object.keys(errors).length > 0) {
            const firstError = Object.values(errors)[0];
            toast.error(firstError);
        }

        return Object.keys(errors).length === 0;
    };

    // Handle form submit
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setSaving(true);
        setError('');
        setSuccess('');

        try {
            const cleanData: any = { ...formData };
            
            Object.keys(cleanData).forEach(key => {
                if (cleanData[key] === '' || cleanData[key] === null || cleanData[key] === undefined) {
                    delete cleanData[key];
                } else if (key === 'full_day_time' || key === 'half_day_time' || key === 'ot_grace_time') {
                    cleanData[key] = parseFloat(cleanData[key] as string);
                }
            });

            if (settingsExist && settings) {
                await apiClient.put('/company-settings', cleanData);
                toast.success('Company settings updated successfully!');
                setSuccess('Company settings updated successfully!');
            } else {
                await apiClient.patch('/company-settings', cleanData);
                toast.success('Company settings created successfully!');
                setSuccess('Company settings created successfully!');
                setSettingsExist(true);
            }

            await fetchSettings();
            setTimeout(() => setSuccess(''), 3000);
        } catch (error: any) {
            console.error('Error saving settings:', error);
            const errorMessage = error.response?.data?.message || error.message || 'Failed to save company settings';
            setError(errorMessage);
            toast.error(errorMessage);
        } finally {
            setSaving(false);
        }
    };

    // Handle reset
    const handleReset = async () => {
        await fetchSettings();
        toast.info('Settings reloaded');
    };

    // Loading state
    if (loading) {
        return (
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Company Settings" pageTitle="Settings" />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody className="text-center py-5">
                                    <Spinner color="primary" className="me-2" />
                                    <span>Loading company settings...</span>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }

    return (
        <div className="page-content">
            <Container fluid>
                <BreadCrumb title="Company Settings" pageTitle="Settings" />

                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardHeader className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                                <div>
                                    <h5 className="card-title mb-0">Company Settings</h5>
                                    {settings && (
                                        <small className="text-muted">
                                            Last updated: {new Date(settings.updated_at || '').toLocaleString()}
                                        </small>
                                    )}
                                </div>
                                <div className="d-flex gap-2">
                                    <Button
                                        color="secondary"
                                        size="sm"
                                        onClick={handleReset}
                                        disabled={saving}
                                    >
                                        <RefreshCw size={14} className="me-1" />
                                        Reset
                                    </Button>
                                    {!settingsExist && (
                                        <Button
                                            color="primary"
                                            size="sm"
                                            onClick={createSettings}
                                            disabled={saving}
                                        >
                                            <Briefcase size={14} className="me-1" />
                                            Initialize Settings
                                        </Button>
                                    )}
                                </div>
                            </CardHeader>

                            <CardBody>
                                {/* Alerts */}
                                {error && (
                                    <Alert color="danger" className="mb-3">
                                        <AlertCircle size={16} className="me-2" />
                                        {error}
                                        {!settingsExist && (
                                            <Button
                                                color="primary"
                                                size="sm"
                                                className="ms-3"
                                                onClick={createSettings}
                                                disabled={saving}
                                            >
                                                Initialize Now
                                            </Button>
                                        )}
                                    </Alert>
                                )}

                                {success && (
                                    <Alert color="success" className="mb-3">
                                        <CheckCircle size={16} className="me-2" />
                                        {success}
                                    </Alert>
                                )}

                                {/* Settings exist check */}
                                {!settingsExist && !error && (
                                    <Alert color="warning" className="mb-3">
                                        <AlertCircle size={16} className="me-2" />
                                        No company settings found. Please initialize settings to continue.
                                        <Button
                                            color="primary"
                                            size="sm"
                                            className="ms-3"
                                            onClick={createSettings}
                                            disabled={saving}
                                        >
                                            Initialize Settings
                                        </Button>
                                    </Alert>
                                )}

                                {settingsExist && (
                                    <Form onSubmit={handleSubmit}>
                                        {/* Company Information Section */}
                                        <div className="mb-4">
                                            <h6 className="text-primary mb-3">
                                                <Briefcase size={16} className="me-2" />
                                                Company Information
                                            </h6>
                                            <div className="table-responsive">
                                                <Table bordered className="mb-0">
                                                    <tbody>
                                                        <tr>
                                                            <td className="bg-light" style={{ width: '180px', fontWeight: '600' }}>
                                                                Company Name <span className="text-danger">*</span>
                                                            </td>
                                                            <td>
                                                                <Input
                                                                    type="text"
                                                                    name="name"
                                                                    value={formData.name || ''}
                                                                    onChange={handleInputChange}
                                                                    invalid={!!validationErrors.name}
                                                                    bsSize="sm"
                                                                    placeholder="Enter company name"
                                                                />
                                                                {validationErrors.name && (
                                                                    <div className="text-danger small mt-1">{validationErrors.name}</div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="bg-light" style={{ fontWeight: '600' }}>
                                                                <FileText size={14} className="me-1" />
                                                                GST Number
                                                            </td>
                                                            <td>
                                                                <Input
                                                                    type="text"
                                                                    name="gst"
                                                                    value={formData.gst || ''}
                                                                    onChange={handleInputChange}
                                                                    invalid={!!validationErrors.gst}
                                                                    bsSize="sm"
                                                                    placeholder="e.g., 22AAAAA0000A1Z1"
                                                                    style={{ maxWidth: '300px' }}
                                                                />
                                                                {validationErrors.gst && (
                                                                    <div className="text-danger small mt-1">{validationErrors.gst}</div>
                                                                )}
                                                                
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="bg-light" style={{ fontWeight: '600' }}>
                                                                <FileText size={14} className="me-1" />
                                                                PAN Number
                                                            </td>
                                                            <td>
                                                                <Input
                                                                    type="text"
                                                                    name="pan"
                                                                    value={formData.pan || ''}
                                                                    onChange={handleInputChange}
                                                                    invalid={!!validationErrors.pan}
                                                                    bsSize="sm"
                                                                    placeholder="e.g., ABCDE1234F"
                                                                    style={{ maxWidth: '200px' }}
                                                                />
                                                                {validationErrors.pan && (
                                                                    <div className="text-danger small mt-1">{validationErrors.pan}</div>
                                                                )}
                                                                
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="bg-light" style={{ fontWeight: '600' }}>
                                                                <Phone size={14} className="me-1" />
                                                                Contact Number
                                                            </td>
                                                            <td>
                                                                <Input
                                                                    type="tel"
                                                                    name="contact_no"
                                                                    value={formData.contact_no || ''}
                                                                    onChange={handleInputChange}
                                                                    invalid={!!validationErrors.contact_no}
                                                                    bsSize="sm"
                                                                    placeholder="10-digit phone number"
                                                                    maxLength={10}
                                                                    style={{ maxWidth: '200px' }}
                                                                />
                                                                {validationErrors.contact_no && (
                                                                    <div className="text-dangesr small mt-1">{validationErrors.contact_no}</div>
                                                                )}
                                                                
                                                            </td>
                                                        </tr>
                                                        {/* <tr>
                                                            <td className="bg-light" style={{ fontWeight: '600' }}>
                                                                Status
                                                            </td>
                                                            <td>
                                                                <FormGroup check>
                                                                    <Label check>
                                                                        <Input
                                                                            type="checkbox"
                                                                            name="status"
                                                                            checked={formData.status !== false}
                                                                            onChange={handleInputChange}
                                                                        />
                                                                        <span className="ms-2">Active</span>
                                                                    </Label>
                                                                </FormGroup>
                                                            </td>
                                                        </tr> */}
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </div>

                                        {/* Working Hours Section - Two Column Layout */}
                                        <div className="mb-4">
                                            <h6 className="text-primary mb-3">
                                                <Clock size={16} className="me-2" />
                                                Working Hours
                                            </h6>
                                            <div className="table-responsive">
                                                <Table bordered className="mb-0">
                                                    <tbody>
                                                        <tr>
                                                            <td className="bg-light" style={{ width: '180px', fontWeight: '600' }}>
                                                                Working Hours
                                                            </td>
                                                            <td>
                                                                <Row className="g-2">
                                                                    <Col md={6}>
                                                                        <Label className="form-label-sm mb-1">From</Label>
                                                                        <Input
                                                                            type="time"
                                                                            name="working_from_time"
                                                                            value={formData.working_from_time || ''}
                                                                            onChange={handleInputChange}
                                                                            onClick={handleTimeInputClick}
                                                                            invalid={!!validationErrors.working_from_time}
                                                                            bsSize="sm"
                                                                            style={{ cursor: 'pointer' }}
                                                                        />
                                                                        {validationErrors.working_from_time && (
                                                                            <div className="text-danger small mt-1">{validationErrors.working_from_time}</div>
                                                                        )}
                                                                    </Col>
                                                                    <Col md={6}>
                                                                        <Label className="form-label-sm mb-1">To</Label>
                                                                        <Input
                                                                            type="time"
                                                                            name="working_to_time"
                                                                            value={formData.working_to_time || ''}
                                                                            onChange={handleInputChange}
                                                                            onClick={handleTimeInputClick}
                                                                            invalid={!!validationErrors.working_to_time}
                                                                            bsSize="sm"
                                                                            style={{ cursor: 'pointer' }}
                                                                        />
                                                                        {validationErrors.working_to_time && (
                                                                            <div className="text-danger small mt-1">{validationErrors.working_to_time}</div>
                                                                        )}
                                                                    </Col>
                                                                </Row>
                                                                <Row className="g-2 mt-2">
                                                                    <Col md={4}>
                                                                        <Label className="form-label-sm mb-1">Full Day Duration</Label>
                                                                        <Input
                                                                            type="number"
                                                                            step="0.1"
                                                                            name="full_day_time"
                                                                            value={formData.full_day_time || ''}
                                                                            onChange={handleInputChange}
                                                                            invalid={!!validationErrors.full_day_time}
                                                                            bsSize="sm"
                                                                            placeholder="e.g., 8"
                                                                        />
                                                                        {validationErrors.full_day_time && (
                                                                            <div className="text-danger small mt-1">{validationErrors.full_day_time}</div>
                                                                        )}
                                                                        <small className="text-muted d-block mt-1">e.g., 8.0</small>
                                                                    </Col>
                                                                    <Col md={4}>
                                                                        <Label className="form-label-sm mb-1">Half Day Duration</Label>
                                                                        <Input
                                                                            type="number"
                                                                            step="0.1"
                                                                            name="half_day_time"
                                                                            value={formData.half_day_time || ''}
                                                                            onChange={handleInputChange}
                                                                            invalid={!!validationErrors.half_day_time}
                                                                            bsSize="sm"
                                                                            placeholder="e.g., 4"
                                                                        />
                                                                        {validationErrors.half_day_time && (
                                                                            <div className="text-danger small mt-1">{validationErrors.half_day_time}</div>
                                                                        )}
                                                                        <small className="text-muted d-block mt-1">e.g., 4.0</small>
                                                                    </Col>
                                                                    <Col md={4}>
                                                                        <Label className="form-label-sm mb-1">OT Grace Duration</Label>
                                                                        <Input
                                                                            type="number"
                                                                            step="0.1"
                                                                            name="ot_grace_time"
                                                                            value={formData.ot_grace_time || ''}
                                                                            onChange={handleInputChange}
                                                                            invalid={!!validationErrors.ot_grace_time}
                                                                            bsSize="sm"
                                                                            placeholder="e.g., 1"
                                                                        />
                                                                        {validationErrors.ot_grace_time && (
                                                                            <div className="text-danger small mt-1">{validationErrors.ot_grace_time}</div>
                                                                        )}
                                                                        <small className="text-muted d-block mt-1">e.g., 1.0</small>
                                                                    </Col>
                                                                </Row>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </div>

                                        {/* Bank Details Section */}
                                        <div className="mb-4">
                                            <h6 className="text-primary mb-3">
                                                <CreditCard size={16} className="me-2" />
                                                Bank Details
                                            </h6>
                                            <div className="table-responsive">
                                                <Table bordered className="mb-0">
                                                    <tbody>
                                                        <tr>
                                                            <td className="bg-light" style={{ width: '180px', fontWeight: '600' }}>
                                                                Bank Name
                                                            </td>
                                                            <td>
                                                                <Input
                                                                    type="text"
                                                                    name="bank_name"
                                                                    value={formData.bank_name || ''}
                                                                    onChange={handleInputChange}
                                                                    bsSize="sm"
                                                                    placeholder="Enter bank name"
                                                                />
                                                                
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="bg-light" style={{ fontWeight: '600' }}>
                                                                Account Number
                                                            </td>
                                                            <td>
                                                                <Input
                                                                    type="text"
                                                                    name="bank_account_no"
                                                                    value={formData.bank_account_no || ''}
                                                                    onChange={handleInputChange}
                                                                    bsSize="sm"
                                                                    placeholder="Enter account number"
                                                                    style={{ maxWidth: '250px' }}
                                                                />
                                                                
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="bg-light" style={{ fontWeight: '600' }}>
                                                                IFSC Code
                                                            </td>
                                                            <td>
                                                                <Input
                                                                    type="text"
                                                                    name="ifsc_code"
                                                                    value={formData.ifsc_code || ''}
                                                                    onChange={handleInputChange}
                                                                    invalid={!!validationErrors.ifsc_code}
                                                                    bsSize="sm"
                                                                    placeholder="e.g., SBIN0001234"
                                                                    style={{ maxWidth: '200px' }}
                                                                />
                                                                {validationErrors.ifsc_code && (
                                                                    <div className="text-danger small mt-1">{validationErrors.ifsc_code}</div>
                                                                )}
                                                                
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="bg-light" style={{ fontWeight: '600' }}>
                                                                Bank Branch
                                                            </td>
                                                            <td>
                                                                <Input
                                                                    type="text"
                                                                    name="bank_branch"
                                                                    value={formData.bank_branch || ''}
                                                                    onChange={handleInputChange}
                                                                    bsSize="sm"
                                                                    placeholder="Enter branch name"
                                                                />
                                                                
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </div>

                                        {/* Address Section */}
                                        <div className="mb-4">
                                            <h6 className="text-primary mb-3">
                                                <MapPin size={16} className="me-2" />
                                                Address
                                            </h6>
                                            <div className="table-responsive">
                                                <Table bordered className="mb-0">
                                                    <tbody>
                                                        <tr>
                                                            <td className="bg-light" style={{ width: '180px', fontWeight: '600' }}>
                                                                Address
                                                            </td>
                                                            <td>
                                                                <Input
                                                                    type="textarea"
                                                                    name="address"
                                                                    value={formData.address || ''}
                                                                    onChange={handleInputChange}
                                                                    bsSize="sm"
                                                                    rows={3}
                                                                    placeholder="Enter company address"
                                                                />
                                                                
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </div>

                                        {/* Form Actions */}
                                        <div className="mt-4 pt-3 border-top">
                                            <div className="d-flex justify-content-end gap-2">
                                                <Button
                                                    color="secondary"
                                                    onClick={handleReset}
                                                    disabled={saving}
                                                >
                                                    <RefreshCw size={14} className="me-1" />
                                                    Reset
                                                </Button>
                                                <Button
                                                    color="primary"
                                                    type="submit"
                                                    disabled={saving}
                                                >
                                                    {saving ? (
                                                        <>
                                                            <Spinner size="sm" className="me-2" />
                                                            Saving...
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Save size={14} className="me-1" />
                                                            Save Changes
                                                        </>
                                                    )}
                                                </Button>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default CompanySettings;